export function moveItemToIndex<T>(
  items: T[] | undefined | null,
  fromIndex: number,
  toIndex: number,
): T[] {
  // Get the current array data
  const array = Array.isArray(items) ? items : [];

  // Validate indices
  if (
    fromIndex < 0 ||
    fromIndex >= array.length ||
    toIndex < 0 ||
    toIndex >= array.length ||
    fromIndex === toIndex
  ) {
    return array;
  }

  // Create the new array with the item moved to the target position
  const newArray = [...array];
  const [movedItem] = newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, movedItem);
  return newArray;
}
